import type { ReactNode } from 'react';
import React from 'react';

export const InsightTitle: React.FC<{ title: string | ReactNode; extraComponent?: ReactNode }> = ({
  title,
  extraComponent,
}) => {
  if (extraComponent) {
    return (
      <div className="inline-flex w-full items-center justify-between">
        {title}
        {extraComponent}
      </div>
    );
  }

  return <>{title}</>;
};
